<div class="footer solvay">
  Powered by Syensqo Business Service - Information System
  <br>
  ©Syensqo 2023
</div>
